import { render, staticRenderFns } from "./ViewerObservation.vue?vue&type=template&id=de18c4e0"
import script from "./ViewerObservation.vue?vue&type=script&lang=js"
export * from "./ViewerObservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports